
export const catalogosRoutesMap = {
  productoServicio: {
    path: '/catalogo/productoServicio',
    name: 'Productos / Servicios',
  },
  metodoPago: {
    path: '/catalogo/metodoPago',
    name: 'Métodos de Pago',
  },
  clasificador: {
    path: '/catalogo/clasificador',
    name: 'Clasificadores',
  },

}
